import type { VoteFrequency, AgeGroup, ContactFilterStatus, TravelMode } from './enums';

export interface VoterFilter {
  zipCode?: string;
  voteFrequency?: VoteFrequency;
  ageGroup?: AgeGroup;
  contactStatus?: ContactFilterStatus;
  searchName?: string;
  partyAffiliation?: string;
  tagIds?: number[];
  sortBy?: string;
  useTravelDistance?: boolean;
  travelMode?: TravelMode;
  radiusKm?: number;
}

export interface VoterMapFilter {
  contactStatus?: 'contacted' | 'not-contacted';
  zipCodes?: string[];
  party?: string[];
  voteFrequencyMin?: number;
  voteFrequencyMax?: number;
  support?: string[];
  education?: string[];
  conservativeDonor?: boolean;
  liberalDonor?: boolean;
  tagIds?: number[];
}

export function hasActiveFilters(f: VoterMapFilter): boolean {
  return !!(f.contactStatus || f.zipCodes?.length || f.party?.length || f.voteFrequencyMin != null ||
    f.voteFrequencyMax != null || f.support?.length || f.education?.length ||
    f.conservativeDonor != null || f.liberalDonor != null || f.tagIds?.length);
}

export function countActiveFilters(f: VoterMapFilter): number {
  let count = 0;
  if (f.contactStatus) count++;
  if (f.zipCodes?.length) count++;
  if (f.party?.length) count++;
  if (f.voteFrequencyMin != null || f.voteFrequencyMax != null) count++;
  if (f.support?.length) count++;
  if (f.education?.length) count++;
  if (f.conservativeDonor != null) count++;
  if (f.liberalDonor != null) count++;
  if (f.tagIds?.length) count++;
  return count;
}

